export const MeetingsData = [
  {
    id: 1,
    date: "09-02-2023",
    time: "11:00 AM",
    subject: "Donec blandit lectus massa",
    venu: "Society Garder",
  },
  {
    id: 2,
    date: "28-02-2023",
    time: "07:00 PM",
    subject: "Society renovation meeting",
    venu: "Society Office Hall",
  }
];


export const LastMeetings = [
    {
      id: 1,
      date: "10-02-2023",
      time: "11:00 AM",
      subject: "Makar Sankranti Utsav",
      venu: "Society Garder",
    }
  ];
  